const defaultErrorDisplayText = {
    errorLabelText: 'Error',
    connectionTimeoutHeaderText: 'Tiempo de conexión agotado',
    connectionTimeoutMessageText: 'La conexión ha expirado.',
    timeoutHeaderText: 'Tiempo agotado',
    timeoutMessageText: 'El rostro no encajó dentro del óvalo en el tiempo límite. Intenta de nuevo y llena completamente el óvalo con tu rostro.',
    faceDistanceHeaderText: 'Movimiento hacia adelante detectado',
    faceDistanceMessageText: 'Evita acercarte más durante la conexión.',
    multipleFacesHeaderText: 'Múltiples rostros detectados',
    multipleFacesMessageText: 'Asegúrate de que solo haya un rostro frente a la cámara durante la conexión.',
    clientHeaderText: 'Error del cliente',
    clientMessageText: 'La verificación falló debido a un problema del cliente',
    serverHeaderText: 'Problema de servidor',
    serverMessageText: 'No se puede completar la verificación debido a un problema del servidor',
    landscapeHeaderText: 'Orientación horizontal no soportada',
    landscapeMessageText: 'Gira tu dispositivo a la orientación vertical (retrato).',
    portraitMessageText: 'Asegúrate de que tu dispositivo permanezca en orientación vertical (retrato) durante la verificación.',
    tryAgainText: 'Intenta de nuevo',
};

export const EsTexts = {
    cameraMinSpecificationsHeadingText: 'La cámara no cumple con las especificaciones mínimas',
    cameraMinSpecificationsMessageText: 'La cámara debe soportar al menos una resolución de 320*240 y 15 cuadros por segundo.',
    cameraNotFoundHeadingText: 'La cámara no es accesible.',
    cameraNotFoundMessageText: 'Verifica que haya una cámara conectada y que no haya otra aplicación usándola. Puede que necesites ir a la configuración para otorgar permisos a la cámara y cerrar todas las instancias de tu navegador y reintentar.',
    a11yVideoLabelText: 'Cámara web para verificación de vida',
    cancelLivenessCheckText: 'Cancelar verificación de vida',
    goodFitCaptionText: 'Buena encaja',
    goodFitAltText: "Ilustración del rostro de una persona, encajando perfectamente dentro de un óvalo.",
    hintCenterFaceText: 'Centra tu cara',
    hintCenterFaceInstructionText: 'Instrucción: Antes de comenzar la verificación, asegúrate de que tu cámara esté en el centro superior de tu pantalla y centra tu rostro hacia la cámara. Cuando comience la verificación, aparecerá un óvalo en el centro. Se te indicará que te acerques al óvalo y luego que te mantengas quieto. Después de unos segundos, deberías escuchar que la verificación está completa.',
    hintFaceOffCenterText: 'El rostro no está en el óvalo, centra tu rostro hacia la cámara.',
    hintMoveFaceFrontOfCameraText: 'Mueve tu rostro frente a la cámara',
    hintTooManyFacesText: 'Asegúrate de que solo haya un rostro frente a la cámara',
    hintFaceDetectedText: 'Rostro detectado',
    hintCanNotIdentifyText: 'Mueve tu rostro frente a la cámara',
    hintTooCloseText: 'Aléjate',
    hintTooFarText: 'Acércate',
    hintConnectingText: 'Conectando...',
    hintVerifyingText: 'Verificando...',
    hintCheckCompleteText: 'Verificación completa',
    hintIlluminationTooBrightText: 'Muévete a un área más oscura',
    hintIlluminationTooDarkText: 'Muévete a un área más iluminada',
    hintIlluminationNormalText: 'Condiciones de iluminación normales',
    hintHoldFaceForFreshnessText: 'Mantente quieto',
    hintMatchIndicatorText: '50% completado. Sigue acercándote.',
    photosensitivityWarningBodyText: 'Esta verificación parpadea con diferentes colores. Usa precaución si eres fotosensible.',
    photosensitivityWarningHeadingText: 'Advertencia de fotosensibilidad',
    photosensitivityWarningInfoText: 'Algunas personas pueden experimentar ataques epilépticos cuando se exponen a luces de colores. Usa precaución si tú, o alguien en tu familia, tienen una condición epiléptica.',
    photosensitivityWarningLabelText: 'Más información sobre la fotosensibilidad',
    photosensitivyWarningBodyText: 'Esta verificación parpadea con diferentes colores. Usa precaución si eres fotosensible.',
    photosensitivyWarningHeadingText: 'Advertencia de fotosensibilidad',
    photosensitivyWarningInfoText: 'Algunas personas pueden experimentar ataques epilépticos cuando se exponen a luces de colores. Usa precaución si tú, o alguien en tu familia, tienen una condición epiléptica.',
    photosensitivyWarningLabelText: 'Más información sobre la fotosensibilidad',
    retryCameraPermissionsText: 'Reintentar',
    recordingIndicatorText: 'Grabando',
    startScreenBeginCheckText: 'Comenzar a verificar',
    tooFarCaptionText: 'Demasiado lejos',
    tooFarAltText: "Ilustración del rostro de una persona dentro de un óvalo; hay un espacio entre el perímetro del rostro y los límites del óvalo.",
    waitingCameraPermissionText: 'Esperando que permitas el uso de la cámara.',
    ...defaultErrorDisplayText,
};

